import { Flex } from '@approvalmax/ui/src/components';
import { useActiveCompany } from 'modules/common';
import { memo } from 'react';

import { useReportsListColumns } from '../../hooks/useReportsListColumns';
import { ReportsListCard } from '../ReportsListCard/ReportsListCard';
import { useReportsListTiles } from './ReportsListTiles.hooks';

export const ReportsListTiles = memo(() => {
    const company = useActiveCompany();
    const { reports, onReportClick } = useReportsListTiles(company);

    const columnsCount = useReportsListColumns();

    return (
        <Flex container data-qa='reports-list'>
            {reports.map((report) => {
                switch (columnsCount) {
                    case 2:
                        return (
                            <Flex block size={12} spacing='16' key={report.id}>
                                <ReportsListCard company={company} report={report} onClick={onReportClick} />
                            </Flex>
                        );

                    case 3:
                    default:
                        return (
                            <Flex block size={8} spacing='16' key={report.id}>
                                <ReportsListCard company={company} report={report} onClick={onReportClick} />
                            </Flex>
                        );
                }
            })}
        </Flex>
    );
});

ReportsListTiles.displayName = 'ReportsListTiles';
